var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.7998 11.1499C19.7998 15.9824 15.8823 19.8999 11.0498 19.8999C6.21731 19.8999 2.2998 15.9824 2.2998 11.1499C2.2998 6.31741 6.21731 2.3999 11.0498 2.3999C15.8823 2.3999 19.7998 6.31741 19.7998 11.1499Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0703 2.07007C16.0409 2.07007 20.0703 6.09951 20.0703 11.0701C20.0703 13.2492 19.2956 15.2473 18.0068 16.8044L21.6709 20.4685C22.0028 20.8005 22.0028 21.3387 21.6709 21.6707C21.339 22.0025 20.8017 22.0025 20.4697 21.6707L16.8047 18.0056C15.2475 19.2946 13.2497 20.0701 11.0703 20.0701C6.09977 20.0701 2.07035 16.0406 2.07031 11.0701C2.07031 6.09951 6.09975 2.07007 11.0703 2.07007ZM11.0703 3.73804C7.02098 3.73804 3.73828 7.02074 3.73828 11.0701C3.73832 15.1194 7.021 18.4021 11.0703 18.4021C15.1196 18.4021 18.4023 15.1194 18.4023 11.0701C18.4023 7.02074 15.1196 3.73804 11.0703 3.73804Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.af3daf0bac1cd2a1e1d457d776683a74.svg";
export { ForwardRef as ReactComponent };